// Cadastro da fila: liga a pesquisa de satisfação pelo chatbot. Ticket encerrado nesta fila → o bot faz a
// pesquisa na conversa (nota, resolvido, motivo, comentário). Fica no suporte-app (/api/filas/<id>/pesquisa).
import React from "react";
import { Checkbox, FormControlLabel, Typography } from "@material-ui/core";

import suporteApi from "./api";

export const carregarPesquisa = (filaId) => (filaId ? suporteApi.get(`/api/filas/${filaId}/pesquisa`).then((r) => r.data)
  : Promise.resolve({ bot: false }));
export const salvarPesquisa = (filaId, valor) => suporteApi.put(`/api/filas/${filaId}/pesquisa`, valor).then((r) => r.data);

const PesquisaFila = ({ valor, onChange }) => {
  if (!valor) return null;
  return (
    <div style={{ marginTop: 12 }}>
      <FormControlLabel
        control={<Checkbox id="fila-pesquisa-bot" color="primary" checked={!!valor.bot} onChange={(e) => onChange({ ...valor, bot: e.target.checked })} />}
        label="Pesquisa de satisfação pelo chatbot ao encerrar o ticket"
      />
      <Typography variant="caption" color="textSecondary" component="div">
        O bot pergunta a nota, se o problema foi resolvido e o motivo; a resposta entra em Gestão → Pesquisa de satisfação.
        Respeita quem pediu para não receber e o intervalo mínimo entre pesquisas para o mesmo número.
      </Typography>
    </div>
  );
};

export default PesquisaFila;
